import { Component, OnInit, Input, HostBinding, AfterViewInit } from '@angular/core';
import { MFormation, MSession, MSite } from '@argalis-apps/models';
import { CartConfigService } from '../../../cart/services/cart-config/cart-config.service';
import { CatalogConfigService } from '../../services/catalog-config/catalog-config.service';

@Component({
  selector: 'ags-fiche-formation-inscription',
  templateUrl: './fiche-formation-inscription.component.html',
  styleUrls: ['./fiche-formation-inscription.component.scss']
})
export class FicheFormationInscriptionComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  private _filteredSessionList: MSession.ISessionInfo[];
  private _postal: string;
  private _siteId: number;
  private _sessionPageSize = 1;
  private _infoFormation: MFormation.IFormInfo;

  @Input()
  set infoFormation(value: MFormation.IFormInfo) {
    this._infoFormation = null;
    this._infoFormation = value;
    if (this._infoFormation) {
      this.initSiteList();
      this.filteredSessionList = this.getFilteredSessions();
    }
  }
  get infoFormation(): MFormation.IFormInfo {
    return this._infoFormation;
  }
  @Input() public modalite: number;
  @Input()
  public set postal(value: string) {
    this._postal = value;
    this.initSiteList();
  }
  public get postal(): string {
    return this._postal;
  }

  public get selectedSiteId() {
    return this._siteId || 0;
  }
  public set selectedSiteId(value) {
    this._siteId = value;
    this.sessionPage = 0;
    if (this.infoFormation) {
      this.filteredSessionList = this.getFilteredSessions();
    }
  }

  public get filteredSessionList(): MSession.ISessionInfo[] {
    if (!this._filteredSessionList) {
      return [];
    }
    return this._filteredSessionList.slice(
      this.sessionPage * this._sessionPageSize,
      (this.sessionPage + 1) * this._sessionPageSize > this._filteredSessionList.length
        ? this._filteredSessionList.length
        : (this.sessionPage + 1) * this._sessionPageSize
    );
  }
  public set filteredSessionList(value: MSession.ISessionInfo[]) {
    this._filteredSessionList = value;
  }

  public get nbSessionPage(): number {
    if (this._filteredSessionList) {
      return Math.floor((this._filteredSessionList.length - 1) / this._sessionPageSize);
    }
    return null;
  }

  public listeSites: MSite.IFormSite[] = [];
  public sessionPage = 0;
  public cartLink = false;

  constructor(private cartConfigService: CartConfigService, catalogConfigService: CatalogConfigService) {
    this.themeFlag = `${this.themeFlag || ''} ${catalogConfigService.themingClassName}`;
  }

  ngOnInit() {
    this.cartLink = !!(this.cartConfigService.getOptions() || ({} as any)).actif;
  }

  initSiteList() {
    if (this.infoFormation.sessions) {
      this.listeSites = [{ id: 0, libelle: this.postal ? 'Tous les sites à proximité' : 'Tous les sites', postal: '' }];
      this.infoFormation.sessions.forEach(session => {
        session.site.forEach(site => {
          if (site.id !== 0) {
            this.listeSites.push(site);
          }
        });
      });
    }
  }

  getFilteredSessions(): MSession.ISessionInfo[] {
    if (!this.infoFormation) {
      return [];
    }
    if (this.selectedSiteId) {
      return this.infoFormation.sessions.filter(session => {
        return !!session.site.find(site => site.id === this.selectedSiteId);
      });
    }
    if (this.infoFormation.sessions) {
      return this.infoFormation.sessions.filter(session => {
        for (const siteSession of session.site) {
          if (this.listeSites.find(site => site.id === siteSession.id)) {
            return true;
          }
        }
        return false;
      });
    }
    return null;
  }
}
